import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-orden-cobros',
  templateUrl: './orden-cobros.component.html',
  styleUrls: ['./orden-cobros.component.scss']
})
export class OrdenCobrosComponent implements OnInit {

  newForm: FormGroup

  /**
   * Constructor
   * 
   * @param _data 
   * @param { MatDialogRef<OrdenCobrosComponent>} _dialog 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) public _data,
    public _dialog: MatDialogRef<OrdenCobrosComponent>
  ) 
  { 
    this.newForm = this.createForm();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Creación del FormGroup
   * @returns {FormGroup}
   */
  createForm(): FormGroup{
    return new FormGroup({
      orden: new FormControl(this._data.orden, [
        Validators.min(1)
      ])
    });
  }
}
